"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function buildOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$disableParent = _ref.disableParent,
    disableParent = _ref$disableParent === void 0 ? true : _ref$disableParent,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level;
  return _lodash["default"].reduce(options, function (acc, opt) {
    if (_lodash["default"].has(opt, 'children') && !_lodash["default"].isEmpty(opt.children)) {
      var newOpt = _lodash["default"].merge(opt, {
        hasChildren: true,
        level: level,
        disabled: disableParent
      });
      return _lodash["default"].concat(acc, newOpt, buildOptions({
        options: opt.children,
        disableParent: disableParent,
        level: level + 1
      }));
    }
    return _lodash["default"].concat(acc, _lodash["default"].merge(opt, {
      hasChildren: false,
      level: level
    }));
  }, []);
}
var _default = exports["default"] = buildOptions;